import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import TabellaLista from '../../../components/Tabella/TabellaLista';
import { elencoPagineApp } from '../../../../api-client/appPlayer';
import { ChipDestinatari, etichettaDestinatari } from './destinatari';

/*
 * Pagine dell'app SportID Player scritte in HTML e CSS (sportid-docs, interventi del 7-8/10/2026, cap. 1):
 * Coach Bot, Premium e il riquadro Premium della Dashboard, ciascuna nella versione per utenti normali e per utenti Premium. Cambiandole si cambiano testi, foto e prezzi
 * nell'app senza pubblicarne una nuova versione. Le pagine le decide l'app: qui non se ne creano.
 */

export const LIST_URL = '/superadmin/pagine-app';

const dataBreve = (iso) => (iso ? new Date(iso).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '');

export const ListaPagineApp = () => {
    const navigate = useNavigate();
    const [righe, setRighe] = useState(null);
    const [errore, setErrore] = useState('');

    useEffect(() => {
        elencoPagineApp().then((r) => {
            if (!r || r.error) { setErrore(r?.error || 'Impossibile leggere le pagine dell\'app.'); setRighe([]); return; }
            setRighe(r.map((p) => ({ ...p, stato: p.active === false ? 'Spenta' : 'Attiva', per: etichettaDestinatari(p.slug, p.audience) })));
        });
    }, []);

    const data_column = [
        { Header: 'Aggiornata', Footer: 'Aggiornata', accessor: 'updatedAt', compact: true, disableGlobalFilter: true, Cell: ({ value }) => dataBreve(value) },
        { Header: 'Pagina', Footer: 'Pagina', accessor: 'title', larghezza: '40%' },
        { Header: 'Per chi', Footer: 'Per chi', accessor: 'per', Cell: ({ row }) => <ChipDestinatari slug={row.original.slug} audience={row.original.audience} /> },
        {
            Header: 'Stato',
            Footer: 'Stato',
            accessor: 'stato',
            disableGlobalFilter: true,
            Cell: ({ row }) => (
                <div className="d-flex align-items-center">
                    <i className={`fa fa-circle me-1 ${row.original.active === false ? 'text-warning' : 'text-success'}`}></i>
                    <div>{row.original.stato}</div>
                </div>
            ),
        },
    ];

    return (
        <>
            <Modal show={!!errore} onHide={() => setErrore('')} centered>
                <Modal.Header closeButton><Modal.Title>Errore durante l'operazione</Modal.Title></Modal.Header>
                <Modal.Body>{errore}</Modal.Body>
            </Modal>
            <TabellaLista
                openColumn={'title'}
                openRow={(row) => navigate(`${LIST_URL}/${row.slug}`)}
                cardTitle={'Pagine dell\'app'}
                pageList={true}
                hasSearch={true}
                searchPlaceholder={'Cerca per pagina'}
                hasFilter={false}
                hasAddMore={false}
                data_column={data_column}
                data_json={righe}
                sort_by={'title'}
                sort_type={'asc'}
            />
        </>
    );
};

export default ListaPagineApp;
